import { useState } from "react";
import BrandHeader from "@/components/BrandHeader";
import AmountForm from "@/components/AmountForm";
import PixPanel from "@/components/PixPanel";
import Footer from "@/components/Footer";

export default function CheckoutPage() {
  const [payment, setPayment] = useState(null);

  const handleReset = () => setPayment(null);

  return (
    <div className="app-shell">
      <main className="flex-1 w-full pt-10 sm:pt-14 pb-10">
        <div className="container-narrow">
          <BrandHeader />
          {!payment ? (
            <AmountForm onCreated={setPayment} />
          ) : (
            <PixPanel payment={payment} onReset={handleReset} />
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
